import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=1d19a5ec&scoped=true&"
import script from "./Photos.vue?vue&type=script&lang=ts&"
export * from "./Photos.vue?vue&type=script&lang=ts&"
import style0 from "./Photos.vue?vue&type=style&index=0&id=1d19a5ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19a5ec",
  null
  
)

export default component.exports